"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _Illustration2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Illustration"));
var _Button = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Button"));
var _TextLink = _interopRequireDefault(require("@kiwicom/orbit-components/lib/TextLink"));
var _Text = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Text"));
var _Stack = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Stack"));
var _context = require("../../../services/auth/context");
var _context2 = require("../../../services/brand/context");
var _jsxRuntime = require("react/jsx-runtime");
var _Illustration, _FormattedMessage, _FormattedMessage2;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const PanelTop = ({
  hidePanel
}) => {
  const {
    onOpenModal
  } = (0, _context.useAuth)();
  const {
    company_name: companyName
  } = (0, _context2.useBrand)();
  const handleOpenModal = React.useCallback(args => {
    onOpenModal(args);
    hidePanel();
  }, [hidePanel, onOpenModal]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack.default, {
    spaceAfter: "medium",
    children: [_Illustration || (_Illustration = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Illustration2.default, {
      dataTest: "TopNav-PanelTop",
      name: "MobileApp",
      size: "medium",
      spaceAfter: "normal"
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
      type: "secondary",
      align: "center",
      spaceAfter: "normal",
      size: "large",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
        id: "navbar.sidepanel.manage_trips",
        values: {
          companyName
        }
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
      onClick: () => handleOpenModal({}),
      fullWidth: true,
      size: "large",
      children: _FormattedMessage || (_FormattedMessage = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
        id: "navbar.header.sign_in"
      }))
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
      align: "center",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextLink.default, {
        onClick: () => handleOpenModal({
          initialScreen: "signUp"
        }),
        type: "primary",
        children: _FormattedMessage2 || (_FormattedMessage2 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
          id: "navbar.header.create_account"
        }))
      })
    })]
  });
};
var _default = PanelTop;
exports.default = _default;